import { render } from "./view.vue?vue&type=template&id=d4bf484e&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=d4bf484e&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4bf484e"]])

export default __exports__